import {
  Box,
  CircularProgress,
  LinearProgress,
  Stack,
  Typography,
} from "@mui/material";

import { AppLoaderProps } from "./types";

const AppLoader = ({
  fullScreen = false,
  text,
  size = 36,
  displayVariant = "circular",
  ...props
}: AppLoaderProps) => {
  const content = (
    <Stack
      spacing={1.5}
      justifyContent="center"
      alignItems="center"
    >
      {displayVariant === "linear" ? (
        <Box sx={{ width: "100%", minWidth: 220 }}>
          <LinearProgress />
        </Box>
      ) : (
        <Box sx={{ p: 1.25, borderRadius: 2, bgcolor: "primary.50" }}>
          <CircularProgress size={size} {...props} />
        </Box>
      )}

      {text && (
        <Typography
          variant="body2"
          color="text.secondary"
        >
          {text}
        </Typography>
      )}
    </Stack>
  );

  if (fullScreen) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        {content}
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      py={4}
    >
      {content}
    </Box>
  );
};

export default AppLoader;
